import { Outlet } from 'react-router';

/** Onboarding page shell. Width follows the platform Helpdesk container. */
export function OnboardingLayout() {
  return (
    <div className="w-full min-w-0 space-y-6">
      <Outlet />
    </div>
  );
}
